import useSWR from 'swr'
import API from '../../../utils/api'
import { MYBALANCE } from '../../constants/APIKEYS'
import { useToken } from '../auth/token'
// import { getPersistData } from '../persist'

// const KEY = MYBALANCE

export function useBalance(symbol?: string, type = 0) {
	const { data: token } = useToken()
	if (symbol === undefined) symbol = 'KRW'
	const SWRKEY = MYBALANCE + '?symbol=' + symbol + '&type=' + type

	const { data, mutate } = useSWR<any>(
		SWRKEY,
		async () => {
			if (symbol === undefined) return 0
			const response = await API.get(SWRKEY, token + '', {}, false)
			return response.result.result[0]
		},
		{
			revalidateOnFocus: true,
			revalidateOnReconnect: true,
			revalidateIfStale: true,
		}
	)

	return {
		data,
		mutate: (value?: any) => {
			return mutate()
		},
	}
}
